import * as React from 'react';
export const baseSvg = React.forwardRef(function baseSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3 5.054c0-.704 0-1.055.133-1.326a1.3 1.3 0 0 1 .595-.595C3.998 3 4.35 3 5.054 3h21.892c.704 0 1.055 0 1.326.133a1.3 1.3 0 0 1 .595.595c.133.27.133.622.133 1.326v21.892c0 .704 0 1.055-.133 1.326a1.3 1.3 0 0 1-.595.595c-.27.133-.622.133-1.326.133H5.054c-.704 0-1.055 0-1.326-.133a1.3 1.3 0 0 1-.595-.595C3 28.002 3 27.65 3 26.946V5.054Z',
      fill: '#00F',
    }),
  );
});
baseSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var base = {
  category: 'brand',
  colorable: false,
  name: 'base',
  svg: baseSvg,
};
